import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { InterceptorService } from "@avaldigitallabs/bpop-security-frontend-lib";
import { Observable } from "rxjs";
import { tap } from "rxjs/internal/operators";

import { CustomerService } from "../../services/local/customer.service";

import { environment } from "../../../environments/environment";

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  constructor(
    private customerService: CustomerService,
    private interceptorService: InterceptorService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.shouldEncryptUrl(req)) {
      return this.interceptorService.handlerInterceptor(
        this.buildAdditionalParams(req),
        next,
      );
    } else {
      return next.handle(this.buildAdditionalParams(req)).pipe(
        tap(
          (event: any) => {
            if (event instanceof HttpResponse) {
              if (event.status === 206) {
                // eslint-disable-next-line no-console
                console.log(event.status);
              }
            }
          },
          (error: any) => {
            if (error instanceof HttpErrorResponse) {
              if (error.status === 401 || error.status === 403) {
                // eslint-disable-next-line no-console
                console.log(error.status);
              }
            }
          },
        ),
      );
    }
  }

  private buildAdditionalParams(req: HttpRequest<any>): any {
    if (!req.headers.get("X-Amz-Security-Token")) {
      let accessToken = "";
      const customerInfo = this.customerService.getCustomer();

      if (customerInfo && customerInfo.accessToken) {
        accessToken = customerInfo.accessToken;
      }

      if (
        req.url.substring(0, 35) === "https://s3.us-east-2.amazonaws.com/" ||
        req.url.includes("s3.us-east-2.amazonaws.com/")
      ) {
        return req;
      } else {
        return req.clone({
          headers: req.headers.append("Authorization", accessToken),
        });
      }
    } else {
      return req;
    }
  }

  private shouldEncryptUrl(req: HttpRequest<any>): boolean {
    return (
      environment.encryptUrls.filter(
        (encryptUrl: any) =>
          encryptUrl === req.url || req.url.includes(encryptUrl),
      ).length !== 0
    );
  }
}
